/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {Link} from 'react-router-dom'
import {Component, ComponentState} from '../../../../store/ducks/component/types'
// import {Extras} from '../../../../store/ducks/extras/types'
import {KTSVG} from '../../../design/helpers'
import {useDispatch} from 'react-redux'
import {
  deleteComponentRequest,
  // updateComponentRequest,
} from '../../../../store/ducks/component/actions'
import {useNavigate} from 'react-router-dom'

import Create from './create'
import Update from './update'
import { Campaign, CampaignState } from '../../../../store/ducks/campaign/types'
import { deleteCampaignRequest } from '../../../../store/ducks/campaign/actions'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../../../store'
const MOMENT = require('moment')
require("moment-duration-format");

type Props = {
  className: string
  campaigns: CampaignState
}

const doaPara = (bloodtype: string) => {
  switch (bloodtype) {
    case '1':
      return "A+, A-, B+, B-, AB+, AB-, O+, O-" //O-
    case '2':
      return "A+, B+, AB+, AB-" //O+
    case '3':
      return "A+, A-, AB+, AB-" //A-
    case '4':
      return "A+, AB+" //A+
    case '5':
      return "B+, B-, AB+, AB-" //B-
    case '6':
      return "B+, AB+" //B+
    case '7':
      return "AB+, AB-" //AB-
    case '8':
      return "AB+" //AB+
    default:
      return "Invalido"
  }
}

const recebeDe = (bloodtype: string) => {
  switch (bloodtype) {
    case '1':
      return "O-" //O-
    case '2':
      return "O+, O-" //O+
    case '3':
      return "A-, O-" //A-
    case '4':
      return "A+, A-, O+, O-" //A+
    case '5':
      return "B-, O-" //B-
    case '6':
      return "B+, B-, O+, O-" //B+
    case '7':
      return "A-, B-, AB-, O-" //AB-
    case '8':
      return "A+, A-, B+, B-, AB+, AB-, O+, O-" //AB+
    default:
      return "Invalido"
  }
}

const bloodtypetext = (bloodtype: string) => {
  switch (bloodtype) {
    case '1':
      return "O-"
    case '2':
      return "O+"
    case '3':
      return "A-"
    case '4':
      return "A+"
    case '5':
      return "B-"
    case '6':
      return "B+"
    case '7':
      return "AB-"
    case '8':
      return "AB+"
    default:
      return "Invalido"
  }
}

const ManageItemWidget: React.FC<React.PropsWithChildren<Props>> = ({className, campaigns}) => {
  console.log('COMP AQUI', campaigns)
  const [show, setShow] = useState<boolean>(false)
  const [action, setAction] = useState<string>('')
  const [child, setChild] = useState<Campaign>({})
  const me = useSelector((state: ApplicationState) => state.me)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleClose = () => {
    setShow(false)
  }

  const createComponent = () => {
    setAction('createComponent')
    setShow(true)
  }

  const updateComponent = (child: Campaign) => {
    setAction('updateComponent')
    setShow(true)
    setChild(child)
  }

  // Deleta componente: CHILD
  const deleteComponent = (campaign: Campaign) => {
    dispatch(deleteCampaignRequest(campaign.id!))
  }

  // const toggleStatus = (component: Component) => {
  //   // console.log('Toggle', component.status);
  //   component.status = !component.status
  //   dispatch(updateComponentRequest(component))
  // }
  if (!me.logged)
    return (
      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Você não está logado</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Crie campanhas para doação de sangue gratuitamente</span>
          </h3>
        </div>
        <div className='card-body py-3'>
          <Link to={'/auth/login'}>
            Clique aqui para entrar ou criar sua conta Salve Mais Um gratuitamente
          </Link>
        </div>
      </div>
    )
  return (
    <>
      <Modal
        size='lg'
        show={show}
        onHide={handleClose}
        enforceFocus={false}
        // centered
        backdrop='static'
        keyboard={false}
        fullscreen={'sm-down'}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {action === 'createComponent' ? 'Nova campanha' : ''}
            {action === 'updateComponent' ? 'Editar campanha' : ''}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {action === 'createComponent' ? <Create handleClose={handleClose} /> : ''}
          {action === 'updateComponent' ? <Update handleClose={handleClose} child={child} /> : ''}
        </Modal.Body>
      </Modal>

      <div className={`card ${className}`}>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-3 mb-1'>Minhas campanhas</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Gerencie suas campanhas</span>
          </h3>
          <div
            className='card-toolbar'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            data-bs-trigger='hover'
            title='Click to add a user'
          >
            <a
              href='#'
              className='btn btn-sm btn-primary'
              // data-bs-toggle='modal'
              // data-bs-target='#kt_modal_invite_friends'
              onClick={() => createComponent()}
            >
              <KTSVG path='media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Criar campanha
            </a>
          </div>
        </div>
        {/* end::Header */}
        {/* begin::Body */}
        <div className='card-body py-3'>
          {/* begin::Table container */}
          <div className='table-responsive'>
            {/* begin::Table */}
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              {/* begin::Table head */}
              <thead>
                <tr className='fw-bolder text-muted'>
                  {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-9-check'
                    />
                  </div>
                </th> */}
                  <th className='w-25px'>Data</th>
                  <th className='w-150px'>Imagem</th>
                  <th className='min-w-50px'>Nome</th>
                  {/* <th className='min-w-140px'>Tipo Sanguíneo</th> */}
                  {/* <th className='min-w-140px'>Recebe</th> */}
                  {/* <th className='min-w-140px'>Hemocentro</th> */}
                  {/* <th className='min-w-140px'>Cidade</th> */}
                  {/* <th className='min-w-140px'>Estado</th> */}
                  {/* <th className='min-w-120px'>Progress</th> */}
                  <th className='min-w-100px text-end'>Ações</th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              
              <tbody>
                
                {campaigns.mycampaigns?.map((child: Campaign, index: any) => {
                  let created_at_text = MOMENT(Number(child.created_at) * 1000) //.format('DD/MM/YYYY HH:mm')
                  return (
                    <tr key={index}>
                      {/* <td>
                      <div className='form-check form-check-sm form-check-custom form-check-solid'>
                        <input className='form-check-input widget-9-check' type='checkbox' value='1' />
                      </div>
                    </td> */}
                     <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> */}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {created_at_text.format('DD/MM/YY')}
                        </span>
                      </td>
                      <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> */}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          <img 
                            src={'../../files/' + child.image} 
                            style={{width: '100%'}} 
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src="https://salvemaisum.com.br/media/guestuser.jpg";
                            }}
                          />
                        </span>
                      </td>
                      <td>
                        <div className='d-flex align-items-center'>
                          {/* <div className='symbol symbol-45px me-5'>
                          <img src={toAbsoluteUrl('/media/avatars/150-11.jpg')} alt='' />
                        </div> */}
                          <div className='d-flex justify-content-start flex-column'>
                            <Link
                              to={'/campanha/' + child.id}
                              style={{display: 'flex'}}
                              className='text-dark fw-bolder text-hover-primary fs-6'
                            >
                              {child.name}
                            </Link>
                            {/* <span className='text-muted fw-bold text-muted d-block fs-7'>
                            {child.description}
                          </span> */}
                          </div>
                        </div>
                      </td>
                      {/* <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> *x/}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {child.bcParent?.name} {child.bcParent?.stateParent?.name}
                        </span>
                      </td> */}
                      {/* <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> *x/}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {recebeDe(child.bloodtype!)}
                        </span>
                      </td> */}
                      
                      {/* <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> *x/}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {child.bcname}
                        </span>
                      </td> */}
                      {/* <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> *x/}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {child.cityParent?.name}
                        </span>
                      </td> */}
                      {/* <td>
                        {/* <a href='#' className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                        Intertico
                      </a> *x/}
                        <span className='text-muted fw-bold text-muted d-block fs-7'>
                          {child.stateParent?.name}
                        </span>
                      </td> */}
                      {/* <td className='text-end'>
                      <div className='d-flex flex-column w-100 me-2'>
                        <div className='d-flex flex-stack mb-2'>
                          <span className='text-muted me-2 fs-7 fw-bold'>50%</span>
                        </div>
                        <div className='progress h-6px w-100'>
                          <div
                            className='progress-bar bg-primary'
                            role='progressbar'
                            style={{width: '50%'}}
                          ></div>
                        </div>
                      </div>
                    </td> */}
                      <td>
                        <div className='d-flex justify-content-end flex-shrink-0'>
                          {/* <a
                            href='#'
                            onClick={() => navigate('/campanha/' + child.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen019.svg'
                              className='svg-icon-3'
                            />
                          </a> */}
                          <a
                            href='#'
                            onClick={() => updateComponent(child)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          >
                            <KTSVG
                              path='/media/icons/duotune/art/art005.svg'
                              className='svg-icon-3'
                            />
                          </a>
                          <a
                            href='#'
                            onClick={() => {
                              if (window.confirm('Deseja realmente excluir: ' + child.name + '?'))
                                deleteComponent(child)
                            }}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/gen027.svg'
                              className='svg-icon-3'
                            />
                          </a>
                        </div>
                      </td>
                    </tr>
                  )
                })}
              </tbody>
              
              {/* end::Table body */}
            </table>
            {campaigns.mycampaigns.length === 0 && <div style={{padding: 10}}>Nenhuma campanha criada. Crie sua primeira campanha clicando em 'Criar campanha'.</div>}
            {/* end::Table */}
          </div>
          {/* end::Table container */}
        </div>
        {/* begin::Body */}
      </div>
    </>
  )
}

export {ManageItemWidget}
